import type { FC } from 'react';
import type { OrderLineOptionDto } from '../../../../../../generated-api';
import CartItemOptions from '../CartItemOptions';
import DisplayComment from './Comment/DisplayComment';
import DisplayGiftCardPhoneNumber from './GiftCardPhoneNumber/DisplayGiftCardPhoneNumber';

interface Props {
  name: string;
  quantity?: number | null;
  hasWeight: boolean;
  displayQuantity?: number | null;
  unitLabel?: string | null;
  options: OrderLineOptionDto[];
  giftCardId?: string;
  giftCardPhoneNumber?: string;
  comment?: string | null;
  dataCy?: string;
}

/**
 * Reusable component for displaying cart item details (name, weight, options, gift card, comment)
 * Used by both regular cart items and composite product components
 */
const CartItemDetails: FC<Props> = ({
  name,
  quantity,
  hasWeight,
  displayQuantity,
  unitLabel,
  options,
  giftCardId,
  giftCardPhoneNumber,
  comment,
  dataCy,
}) => {
  const hasOptions = options.length > 0;
  const hasGiftCardPhoneNumber = giftCardId && giftCardPhoneNumber;
  const hasComment = comment && comment.length > 0;

  return (
    <div className="max-w-xs pb-2" data-cy={dataCy}>
      <div className="text-bold text-small truncate-2">
        {quantity != null && quantity > 1 && `${quantity}x`} {name}
      </div>
      {hasWeight && displayQuantity !== null && (
        <div className="text-xs text-grey-dark">
          {displayQuantity} {unitLabel}
        </div>
      )}
      {hasOptions && <CartItemOptions options={options} />}
      {hasGiftCardPhoneNumber && <DisplayGiftCardPhoneNumber phone={giftCardPhoneNumber} />}
      {hasComment && <DisplayComment comment={comment ?? ''} />}
    </div>
  );
};

export default CartItemDetails;
